import { createSlice } from '@reduxjs/toolkit';
import { ROLES } from '../../constants/roles';
import Cookies from 'js-cookie';

const initialState = {
  token: Cookies.get('token') || null,
  role: Cookies.get('role') || null,
  user: {},
};
const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    login(state, action) {
      state.token = action.payload.token;
      Cookies.set('token', action.payload.token, { expires: 7 });
      Cookies.set('role', action.payload.role, { expires: 7 });
      localStorage.setItem('currentUserID', action.payload.id);
      state.role = action.payload.role;
      state.user = action.payload.user;
    },
    logout(state) {
      state.token = null;
      Cookies.remove('token');
      Cookies.remove('role');
      localStorage.removeItem('currentUserId');
      state.role = '';
      state.user = {};
    },
  },
});

export const { login, logout } = userSlice.actions;
export default userSlice.reducer;
